module.exports = __webpack_public_path__ + "static/media/describe.cdb013e3.png";